/**
 * Header Store - Global Header State Management
 *
 * Manages:
 * - Scroll detection (for intelligent hiding/showing)
 * - Search bar toggle
 * - Mobile menu state
 *
 * Usage in templates:
 * - Get scroll state: $store.header.scrolled
 * - Get hidden state: $store.header.hidden
 * - Toggle search: $store.header.toggleSearch()
 */

export default {
  scrolled: false,
  hidden: false,
  searchOpen: false,
  lastScrollY: 0,
  scrollThreshold: 10,
  hideThreshold: 80,

  init() {
    this.updateHeaderHeight();
    window.addEventListener('scroll', () => this.handleScroll());
    window.addEventListener('resize', () => this.updateHeaderHeight());
  },

  updateHeaderHeight() {
    const header = document.getElementById('main-header');
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
  },

  handleScroll() {
    const currentScrollY = window.scrollY;

    this.scrolled = currentScrollY > this.scrollThreshold;

    if (currentScrollY > this.lastScrollY && currentScrollY > this.hideThreshold) {
      this.hidden = true;
    } else if (currentScrollY < this.lastScrollY) {
      this.hidden = false;
    }

    this.lastScrollY = currentScrollY;
  },

  toggleSearch() {
    this.searchOpen = !this.searchOpen;

    if (this.searchOpen) {
      this.$nextTick(() => {
        const searchInput = document.querySelector('input[name="query"]');
        if (searchInput) {
          searchInput.focus();
        }
      });
    }
  },

  openSearch() {
    this.searchOpen = true;
    this.$nextTick(() => {
      const searchInput = document.querySelector('input[name="query"]');
      if (searchInput) {
        searchInput.focus();
      }
    });
  },

  closeSearch() {
    this.searchOpen = false;
  },

  get headerClasses() {
    return [
      this.scrolled ? 'bg-background/95 shadow-xl backdrop-blur-md' : '',
      this.hidden ? '-translate-y-full' : 'translate-y-0'
    ];
  }
};
